module.exports = __webpack_public_path__ + "img/card-coin.cdc56617.svg";